var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeaf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7316 2.66667V4.33333C13.7316 6.72667 11.7395 8.66667 9.28189 8.66667H7.57049V12H6.20136V7.33333L6.21436 6.66667C6.38893 4.42933 8.30913 2.66667 10.651 2.66667H13.7316ZM2.77854 0C4.89521 0 6.6915 1.33667 7.3261 3.19067C6.29925 4.04067 5.62153 5.276 5.52775 6.66667H4.83223C2.18571 6.66667 0.0402832 4.57733 0.0402832 2V0H2.77854Z",
    fill: "#E09200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaf);
export default __webpack_public_path__ + "static/media/leaf.4d005e3d627575b0d77303f80b4f5194.svg";
export { ForwardRef as ReactComponent };